/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Project scope biodiversity features
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProjectScopeBiodiversityFeatures { 
    /**
     * Miradi formatted_text fields (allows limited html markup)
     */
    biodiversityNotes?: string;

    constructor(item?: Partial<ProjectScopeBiodiversityFeatures>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            biodiversityNotes: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.biodiversityNotes : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProjectScopeBiodiversityFeatures.isValid,
        };
    }

    static isValid(obj: ProjectScopeBiodiversityFeatures): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProjectScopeBiodiversityFeatures.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.biodiversityNotes.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

